// Collapse N stage_presence_logs into a single confidence summary
// for the producer's per-assignment row. Rule:
//   * empty list → 'no_presence' (crew never logged inside this stage
//                  during the assignment window — distinct from
//                  unknown metadata)
//   * any NULL source → 'unknown' (entire assignment taints —
//                       pre-fallback row that couldn't be backfilled)
//   * else any 'within_accuracy' → fallback + worst distance
//   * else all 'strict' → strict, distance 0
// The conservative bias is intentional: a single mystery row in an
// otherwise-clean assignment is exactly the case where the producer
// should be cautious about the compliance %.

type LogLike = {
  entry_match_source: "strict" | "within_accuracy" | null;
  entry_match_distance_m: number | null;
};

export type MatchConfidenceSummary = {
  source: "strict" | "within_accuracy" | "no_presence" | null;
  worstDistanceM: number | null;
};

export function summarizeMatchConfidence(logs: LogLike[]): MatchConfidenceSummary {
  if (logs.length === 0) return { source: "no_presence", worstDistanceM: null };
  const hasNull = logs.some((l) => l.entry_match_source === null);
  if (hasNull) return { source: null, worstDistanceM: null };
  const fallback = logs.filter((l) => l.entry_match_source === "within_accuracy");
  if (fallback.length > 0) {
    const worst = fallback.reduce((max, l) => {
      const d = l.entry_match_distance_m ?? 0;
      return d > max ? d : max;
    }, 0);
    return { source: "within_accuracy", worstDistanceM: worst };
  }
  return { source: "strict", worstDistanceM: 0 };
}
